module.exports = __webpack_public_path__ + "img/s00164.3ea5fbeb.png";